import React, { Component } from "react";
import CartContext from "./CartContext";
import { BiRefresh, BiBarChart } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import { Link } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import Fuse from "fuse.js";
import Select from "react-select";
import PropTypes from "prop-types";
import { FaWhatsapp } from "react-icons/fa";

import {
  OverlayTrigger,
  FloatingLabel,
  Stack,
  Tooltip,
  FormControl,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Tabs,
  Tab,
  Table,
  Navbar,
} from "react-bootstrap";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line, Bar, Pie } from "react-chartjs-2";

// register chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  ChartTooltip,
  Legend,
  Filler
);

export class SalesOrders extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      salesorders: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      loaded: false,
      loadSpinnerOpen: false,
      addModalShow: false,
      key: "NewOrders",
      ShowNewTabRefresh: true,
      ShowPartiallyTabRefresh: false,
      ShowDeliveredTabRefresh: false,
      warehouse: [],
      prods: [],
      showAnalytics: false,
    };
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });

  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  GetsInventories = () => {
    this.ShowLoadSpinner();
    this.setState({ prods: [] }, () => {
      fetch(
        process.env.REACT_APP_API +
          "StoreManager/GetProducts/" +
          this.context.storeId
      )
        .then((response) => response.json())
        .then((data) => {
          this.HideLoadSpinner();
          if (data.status !== 400) {
            this.setState({ prods: data });
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.HideLoadSpinner();
        });
    });
  };

  GetWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status !== 400) {
          this.setState({ warehouse: data });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  GetSalesOrders = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "SalesOrder/GetSalesOrders/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        this.HideLoadSpinner();
        if (data.status !== 400) {
          this.setState({ salesorders: data, reload: true });
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        console.error("There was an error!", error);
      });
  };

  OnRefreshButtonClick = () => {
    this.setState({ salesorders: [] }, this.GetSalesOrders);
  };

  OnSaved = () => this.OnRefreshButtonClick();
  OnDeleted = () => this.OnRefreshButtonClick();

  AddModalShow = () => this.setState({ addModalShow: true });
  addModalClose = () => {
    this.setState({ addModalShow: false });
    this.OnRefreshButtonClick();
  };

  openAnalytics = () => this.setState({ showAnalytics: true });
  closeAnalytics = () => this.setState({ showAnalytics: false });

  ShowSelectedTab = (k) => {
    this.setState({
      ShowNewTabRefresh: false,
      ShowPartiallyTabRefresh: false,
      ShowDeliveredTabRefresh: false,
    });

    if (k === "NewOrders") this.setState({ ShowNewTabRefresh: true });
    if (k === "PartiallyDelivered")
      this.setState({ ShowPartiallyTabRefresh: true });
    if (k === "Delivered") this.setState({ ShowDeliveredTabRefresh: true });
  };

  componentDidMount = () => {
    if (!this.state.loaded) {
      this.GetSalesOrders();
      this.GetsInventories();
      this.GetWarehouses();
      this.state.loaded = true;
    }
    window.scrollTo(0, 0);
    document.addEventListener("keydown", (event) => {
      if (event.key === "F8") this.AddModalShow();
      else if (event.key === "F9") this.OnRefreshButtonClick();
    });
  };

  render() {
    return (
      <div className="Container-fluid p-0">
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}

        <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
          <h4> Sales Orders </h4>
          <Navbar.Collapse className="justify-content-end mx-0 ">
            <Nav>
              <ButtonToolbar className="text-end align-middle">
                <Button
                  size="sm"
                  className="mainthemecolor"
                  onClick={() => this.setState({ addModalShow: true })}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-plus"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  &nbsp;Add (F8)
                </Button>
                &nbsp;
                <Button
                  className="mainthemecolor"
                  size="sm"
                  onClick={this.OnRefreshButtonClick}
                >
                  <BiRefresh size="16" />
                  &nbsp;Refresh (F9)
                </Button>
                &nbsp;
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={this.openAnalytics}
                  title="Show Analytics Dashboard"
                >
                  <BiBarChart size={16} /> &nbsp;Analytics
                </Button>
                &nbsp;
                {this.state.addModalShow && (
                  <SalesOrderAddOrEditModal
                    show={this.state.addModalShow}
                    Type="Add"
                    onHide={this.addModalClose}
                    refresh={this.OnRefreshButtonClick}
                    prods={this.state.prods}
                    warehouse={this.state.warehouse}
                    GetsInventories={this.GetsInventories}
                  />
                )}
              </ButtonToolbar>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div className="purposestyle p-2">
          <b>Purpose:</b> Use this module to enter all **Sales Orders** to
          Customers. Stocks in the Product Inventory will get deducted upon
          creating a new Sales Order.
        </div>

        {this.state.salesorders.length > 0 && (
          <Tabs
            id="salesorder-tabs"
            activeKey={this.state.key}
            onSelect={(k) => this.setState({ key: k })}
            className="mb-3 bg-light fw-bold"
            fill
            style={{ fontSize: "16px" }}
          >
            <Tab
              eventKey="NewOrders"
              title={
                "1. New (" +
                this.state.salesorders.filter((f) => f.status == 1).length +
                ")"
              }
            >
              <SalesOrdersTable
                status="1"
                salesorders={this.state.salesorders}
                refresh={this.OnRefreshButtonClick}
                prods={this.state.prods}
                warehouse={this.state.warehouse}
                GetsInventories={this.GetsInventories}
              />
            </Tab>

            <Tab
              eventKey="PartiallyDelivered"
              title={
                "2. Partially Delivered (" +
                this.state.salesorders.filter((f) => f.status == 2).length +
                ")"
              }
            >
              <SalesOrdersTable
                status="2"
                salesorders={this.state.salesorders}
                refresh={this.OnRefreshButtonClick}
                prods={this.state.prods}
                warehouse={this.state.warehouse}
                GetsInventories={this.GetsInventories}
              />
            </Tab>

            <Tab
              eventKey="Delivered"
              title={
                "3. Delivered (" +
                this.state.salesorders.filter((f) => f.status == 3).length +
                ")"
              }
            >
              <SalesOrdersTable
                status="3"
                salesorders={this.state.salesorders}
                refresh={this.OnRefreshButtonClick}
                prods={this.state.prods}
                warehouse={this.state.warehouse}
                GetsInventories={this.GetsInventories}
              />
            </Tab>
            <Tab
              eventKey="Cancelled"
              title={
                "4. Cancelled (" +
                this.state.salesorders.filter((f) => f.status == 4).length +
                ")"
              }
            >
              <SalesOrdersTable
                status="4"
                salesorders={this.state.salesorders}
                refresh={this.OnRefreshButtonClick}
                prods={this.state.prods}
                warehouse={this.state.warehouse}
                GetsInventories={this.GetsInventories}
              />
            </Tab>
          </Tabs>
        )}

        {this.state.showAnalytics && (
          <SalesOrdersDashboardModal
            show={this.state.showAnalytics}
            onHide={this.closeAnalytics}
            storeId={this.context.storeId}
            token={this.context.userData?.bearertoken}
            refreshParent={this.OnRefreshButtonClick}
          />
        )}
      </div>
    );
  }
}

/* SalesOrdersTable (inner component) */
class SalesOrdersTable extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      filtered: [],
      query: "",
      searching: false,
      searchMode: "fuzzy",
      paymentStatusFilter: "",
      startDate: "",
      endDate: "",
      warehouseFilter: "", // NEW: selected warehouse id string
    };
    this.searchTimeout = null;
  }

  componentDidMount() {
    this.setState({ filtered: this.props.salesorders || [] }, () =>
      this.runFilter("", this.props.salesorders)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.salesorders !== this.props.salesorders ||
      prevProps.status !== this.props.status
    ) {
      this.runFilter(this.state.query, this.props.salesorders);
    }
  }

  componentWillUnmount() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
  }

  handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the Sales Order!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(process.env.REACT_APP_API + "SalesOrder/DeleteSalesOrder/" + id, {
          method: "DELETE",
        })
          .then((res) => {
            if (res.ok) {
              Swal.fire("Deleted!", "Sales Order deleted.", "success");
              this.props.refresh(); // refresh parent list
            } else {
              Swal.fire("Error", "Failed to delete Sales Order!", "error");
            }
          })
          .catch((err) => {
            Swal.fire("Error", "Exception: " + err, "error");
          });
      }
    });
  };

  onSearchChange = (e) => {
    const q = e.target.value || "";
    this.setState({ query: q, searching: true });

    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.runFilter(q, this.props.salesorders);
      this.setState({ searching: false });
    }, 300);
  };

  onSearchModeChange = (e) => {
    this.setState({ searchMode: e.target.value }, () =>
      this.runFilter(this.state.query, this.props.salesorders)
    );
  };

  onPaymentStatusFilterChange = (e) => {
    this.setState({ paymentStatusFilter: e.target.value }, () =>
      this.runFilter(this.state.query, this.props.salesorders)
    );
  };

  onWarehouseFilterChange = (e) => {
    this.setState({ warehouseFilter: e.target.value }, () =>
      this.runFilter(this.state.query, this.props.salesorders)
    );
  };

  onStartDateChange = (e) => {
    this.setState({ startDate: e.target.value }, () =>
      this.runFilter(this.state.query, this.props.salesorders)
    );
  };

  onEndDateChange = (e) => {
    this.setState({ endDate: e.target.value }, () =>
      this.runFilter(this.state.query, this.props.salesorders)
    );
  };

  clearSearch = () => {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.setState({
      query: "",
      paymentStatusFilter: "",
      startDate: "",
      endDate: "",
      warehouseFilter: "",
    });
    this.runFilter("", this.props.salesorders);
  };

  getDateFromISO = (iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    if (isNaN(d)) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };

  escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  renderHighlighted = (text, query) => {
    if (!query) return text || "";
    if (!text) return "";

    const escaped = this.escapeRegex(query);
    const regex = new RegExp(`(${escaped})`, "ig");
    const parts = text.split(regex);
    return parts.map((part, idx) =>
      regex.test(part) ? (
        <mark key={idx} style={{ background: "yellow", padding: 0 }}>
          {part}
        </mark>
      ) : (
        <span key={idx}>{part}</span>
      )
    );
  };

  runFilter = (query, sourceSalesOrders) => {
    const all = sourceSalesOrders || this.props.salesorders || [];
    let filtered = all.filter((o) => o.status == this.props.status);

    // warehouse filter
    if (this.state.warehouseFilter) {
      filtered = filtered.filter(
        (o) =>
          String(o.warehouseId || "") === String(this.state.warehouseFilter)
      );
    }

    // payment status filter
    if (this.state.paymentStatusFilter) {
      filtered = filtered.filter(
        (o) =>
          (o.paymentStatus || "").toString() ===
          this.state.paymentStatusFilter.toString()
      );
    }

    // date range
    const { startDate, endDate } = this.state;
    let start = startDate ? new Date(startDate) : null;
    let end = endDate ? new Date(endDate) : null;
    if (start)
      start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    if (end)
      end = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1);

    if (start || end) {
      filtered = filtered.filter((o) => {
        const created = this.getDateFromISO(o.created);
        if (!created) return false;
        if (start && created < start) return false;
        if (end && created >= end) return false;
        return true;
      });
    }

    // search
    const q = (query || "").trim();
    if (!q) {
      this.setState({ filtered });
      return;
    }

    if (this.state.searchMode === "exact") {
      const low = q.toLowerCase();
      const fallback = filtered.filter(
        (o) =>
          (o.orderId || "").toString().toLowerCase().includes(low) ||
          (o.quotationNo || "").toString().toLowerCase().includes(low) ||
          (o.customerName || "").toString().toLowerCase().includes(low) ||
          (o.contactNumber || "").toString().toLowerCase().includes(low)
      );
      this.setState({ filtered: fallback });
      return;
    }

    try {
      const fuse = new Fuse(filtered, {
        keys: [
          { name: "orderId", weight: 0.6 },
          { name: "quotationNo", weight: 0.5 },
          { name: "customerName", weight: 0.8 },
          { name: "contactNumber", weight: 0.6 },
        ],
        threshold: 0.45,
        ignoreLocation: true,
      });

      const results = fuse.search(q);
      const mapped = results.map((r) => r.item);
      this.setState({ filtered: mapped });
    } catch (err) {
      const low = q.toLowerCase();
      const fallback = filtered.filter(
        (o) =>
          (o.orderId || "").toString().toLowerCase().includes(low) ||
          (o.quotationNo || "").toString().toLowerCase().includes(low) ||
          (o.customerName || "").toString().toLowerCase().includes(low) ||
          (o.contactNumber || "").toString().toLowerCase().includes(low)
      );
      this.setState({ filtered: fallback });
    }
  };

  /* Replace render() of SalesOrdersTable with this responsive version.
   Assumes SalesOrderAddOrEditModal is available in scope (like before). */

  renderCards = (rows) => {
    return (
      <div className="p-2">
        {rows.length === 0 ? (
          <div className="text-center text-muted py-4">No orders found.</div>
        ) : (
          rows.map((so, idx) => {
            const paidTotal = (
              so.salesOrderPayments || so.salesOrderPayments === undefined
                ? so.salesOrderPayments || []
                : []
            ).reduce((s, p) => s + Number(p.amount || 0), 0);
            return (
              <div className="card mb-2 shadow-sm" key={so.id || idx}>
                <div className="card-body p-2">
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <div className="fw-bold">
                            {so.orderId || `#${idx + 1}`}
                          </div>
                          <div className="small text-muted">
                            {this.context.GetInDateFormat(new Date(so.created))}
                          </div>
                        </div>

                        <div className="text-end">
                          <div className="small text-muted">Warehouse</div>
                          <div className="fw-semibold">
                            {(this.props.warehouse || []).find(
                              (w) => String(w.id) === String(so.warehouseId)
                            )?.name || "-"}
                          </div>
                        </div>
                      </div>

                      <div className="mt-2 d-flex flex-column gap-1">
                        <div>
                          <small className="text-muted">Customer</small>
                          <div className="fw-semibold">
                            {so.customerName} [{so.contactNumber}]
                          </div>
                        </div>

                        <div className="d-flex gap-2 flex-wrap">
                          <div>
                            <small className="text-muted">Payment</small>
                            <div>
                              {so.paymentStatus == 1
                                ? "Paid"
                                : so.paymentStatus == 2
                                ? "Unpaid"
                                : "Partially Paid"}
                            </div>
                          </div>

                          <div>
                            <small className="text-muted">Paid Amount</small>
                            <td>
                              {this.formatCurrency
                                ? this.formatCurrency(paidTotal)
                                : String(paidTotal)}
                            </td>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 d-flex gap-2">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          mobileEditOrder: so,
                          mobileEditShow: true,
                        });
                      }}
                    >
                      Open / Edit
                    </Button>

                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          window.confirm(
                            "Are you sure you want to delete this order?"
                          )
                        ) {
                          // call same delete handler you already have (wired to handleDelete in class)
                          this.handleDelete(so.id);
                        }
                      }}
                    >
                      Delete
                    </Button>

                    <div className="ms-auto small text-muted align-self-center">
                      {so.attachmentFileName ? (
                        <a
                          href={`${this.context.store.storageBlobUrl}${this.context.store.storageBlobContainerName}/so-orders/${so.attachmentFileName}${this.context.store.storageSasToken}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-decoration-none"
                        >
                          Attachment
                        </a>
                      ) : (
                        <span className="text-muted">No Attachment</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  };

  openMobileEdit = (order) => {
    this.setState({ mobileEditOrder: order, mobileEditShow: true });
  };

  closeMobileEdit = () => {
    this.setState({ mobileEditOrder: null, mobileEditShow: false }, () => {
      // refresh parent list if provided
      this.props.refresh && this.props.refresh();
    });
  };

  render() {
    const {
      filtered,
      query,
      searching,
      searchMode,
      paymentStatusFilter,
      startDate,
      endDate,
      warehouseFilter,
    } = this.state;

    const baseRows =
      filtered && filtered.length > 0
        ? filtered.slice()
        : (this.props.salesorders || []).filter(
            (o) => o.status == this.props.status
          );

    const rows = baseRows
      .slice()
      .sort((a, b) => (a.created < b.created ? 1 : -1));
    const warehouses = this.props.warehouse || [];

    // Use a responsive container: table visible on md+, cards on xs/sm
    return (
      <>
        <div className="p-2 d-flex align-items-center flex-wrap gap-2">
          <FormControl
            placeholder="Search by OrderId, QuotationNo, Customer or Mobile..."
            value={query}
            onChange={this.onSearchChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (this.searchTimeout) clearTimeout(this.searchTimeout);
                this.runFilter(query, this.props.salesorders);
              }
            }}
            style={{ minWidth: 160, maxWidth: 520 }}
          />

          <Form.Select
            size="sm"
            value={searchMode}
            onChange={this.onSearchModeChange}
            style={{ width: 140 }}
          >
            <option value="fuzzy">Fuzzy (recommended)</option>
            <option value="exact">Exact</option>
          </Form.Select>

          <Form.Select
            size="sm"
            value={paymentStatusFilter}
            onChange={this.onPaymentStatusFilterChange}
            style={{ width: 160 }}
          >
            <option value="">Payment: All</option>
            <option value="1">Paid</option>
            <option value="2">Unpaid</option>
            <option value="3">Partially Paid</option>
          </Form.Select>

          <Form.Select
            size="sm"
            value={warehouseFilter}
            onChange={this.onWarehouseFilterChange}
            style={{ width: 220 }}
          >
            <option value="">Warehouse: All</option>
            {warehouses.map((w) => (
              <option key={w.id} value={String(w.id)}>
                {w.name}
              </option>
            ))}
          </Form.Select>

          <div className="d-flex align-items-center gap-1">
            <input
              type="date"
              className="form-control form-control-sm"
              value={startDate}
              onChange={this.onStartDateChange}
              title="Start Date"
            />
            <span style={{ fontSize: 12 }}>to</span>
            <input
              type="date"
              className="form-control form-control-sm"
              value={endDate}
              onChange={this.onEndDateChange}
              title="End Date"
            />
          </div>

          <div className="ms-auto d-flex gap-2 align-items-center">
            <div style={{ fontSize: 12 }} className="text-muted">
              {searching
                ? "Searching..."
                : query
                ? `Results for "${query}"`
                : ""}
            </div>
            <Button
              size="sm"
              onClick={() => this.runFilter(query, this.props.salesorders)}
            >
              Search
            </Button>
            <Button size="sm" variant="secondary" onClick={this.clearSearch}>
              Clear
            </Button>
          </div>
        </div>

        {/* Desktop / tablet: table (md and up) */}
        <div
          className="d-none d-md-block bg-white overflow-auto"
          style={{ maxHeight: "calc(100vh - 200px)" }}
        >
          <Table striped className="mb-0">
            <thead>
              <tr className="text-center text-black bg-white">
                <th>#</th>
                <th>Created</th>
                <th>OrderId</th>
                <th>QuotationNo</th>
                <th>Customer</th>
                <th>Warehouse</th>
                <th>Payment Status</th>
                <th>Paid Amount</th>
                <th>CreatedBy</th>
                <th>Options</th>
                <th>Attachment</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((so, i) => (
                  <EditSalesOrderInline
                    key={so.id || i}
                    index={i}
                    salesOrder={so}
                    prods={this.props.prods}
                    warehouse={this.props.warehouse}
                    GetsInventories={this.props.GetsInventories}
                    refresh={this.props.refresh}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center text-muted">
                    No orders found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Mobile: cards (visible on sm/xs) */}
        <div className="d-block d-md-none">{this.renderCards(rows)}</div>

        {/* Mobile edit modal (re-uses existing modal) */}
        {this.state.mobileEditShow && this.state.mobileEditOrder && (
          <SalesOrderAddOrEditModal
            show={this.state.mobileEditShow}
            onHide={this.closeMobileEdit}
            salesOrder={this.state.mobileEditOrder}
            prods={this.props.prods}
            warehouse={this.props.warehouse}
            Type="Edit"
            refresh={() => {
              this.closeMobileEdit();
              this.props.refresh && this.props.refresh();
            }}
            GetsInventories={this.props.GetsInventories}
          />
        )}
      </>
    );
  }
}

/* EditSalesOrderInline.js - updated to show warehouse name and accept warehouse prop */
class EditSalesOrderInline extends Component {
  static contextType = CartContext;

  PERSIST_ATTACHMENT_URL =
    (process.env.REACT_APP_API || "") +
    "SalesOrder/UpdateSalesOrderAttachmentFileName";

  constructor(props) {
    super(props);
    this.state = {
      salesOrder: props.salesOrder,
      editModalShow: false,
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
    };
    this.inputFile = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.salesOrder !== this.props.salesOrder) {
      this.setState({ salesOrder: this.props.salesOrder || {} });
    }
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });

  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  handleDelete = async (e) => {
    if (e && e.stopPropagation) e.stopPropagation();

    const id = this.state.salesOrder?.id;
    if (!id) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the Sales Order!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmed.isConfirmed) return;

    this.ShowLoadSpinner();

    try {
      const filename = this.state.salesOrder?.attachmentFileName;
      if (filename) {
        try {
          await this.deleteBlobInContainer(`so-orders/${filename}`);
        } catch (err) {
          console.warn(
            "Failed to delete blob, continuing with order delete",
            err
          );
          Swal.fire(
            "Warning",
            "Failed to delete attachment blob. Proceeding to delete order.",
            "warning"
          );
        }
      }

      const res = await fetch(
        process.env.REACT_APP_API + "SalesOrder/DeleteSalesOrder/" + id,
        {
          method: "DELETE",
        }
      );

      if (res.ok) {
        Swal.fire("Deleted!", "Sales Order deleted.", "success");
        this.props.refresh();
      } else {
        const txt = await res.text();
        Swal.fire(
          "Error",
          `Failed to delete Sales Order: ${res.status} ${txt}`,
          "error"
        );
      }
    } catch (err) {
      console.error("handleDelete exception", err);
      Swal.fire("Error", "Exception: " + String(err), "error");
    } finally {
      this.HideLoadSpinner();
    }
  };

  onUploadButtonClick = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    this.inputFile.current?.click();
  };

  handleFileChange = async (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0)
      return;
    const file = e.target.files[0];

    // basic size/type checks could be added here
    try {
      this.ShowLoadSpinner();
      const uploadedName = await this.uploadFileToBlob(file);

      // persist the filename in DB (server endpoint must exist)
      if (uploadedName && this.state.salesOrder?.id) {
        try {
          await this.persistAttachmentFileName(
            this.state.salesOrder.id,
            uploadedName
          );
          Swal.fire("Uploaded", "Attachment saved and persisted.", "success");
          // refresh so server-sourced data is visible
          if (this.props.refresh) this.props.refresh();
        } catch (err) {
          console.error("persistAttachmentFileName failed", err);
          Swal.fire(
            "Warning",
            "File uploaded but saving filename to DB failed. See console.",
            "warning"
          );
        }
      } else if (uploadedName && !this.state.salesOrder?.id) {
        // order not saved yet - we uploaded the file but cannot persist it to DB (no id).
        // Inform user to save the order first.
        Swal.fire(
          "Uploaded",
          "File uploaded to storage. Save the order in editor to persist attachment with the order.",
          "info"
        );
      }
    } catch (err) {
      console.error("uploadFile error", err);
      Swal.fire("Error", "Upload failed. See console.", "error");
    } finally {
      this.HideLoadSpinner();
      if (this.inputFile.current) this.inputFile.current.value = "";
    }
  };

  // Upload to Azure and return file name used
  uploadFileToBlob = async (file) => {
    if (!file) return null;

    const orderId = this.state.salesOrder?.id || `temp-${Date.now()}`;
    const ext = file.name.split(".").pop();
    const targetFileName = `${orderId}.${ext}`;

    // build blob client
    const blobService = new BlobServiceClient(
      `${this.context.store.storageBlobUrl}${this.context.store.storageSasToken}`
    );
    const containerClient = blobService.getContainerClient(
      this.context.store.storageBlobContainerName
    );
    const blockBlobClient = containerClient.getBlockBlobClient(
      `so-orders/${targetFileName}`
    );

    const options = { blobHTTPHeaders: { blobContentType: file.type } };
    await blockBlobClient.uploadData(file, options);

    return targetFileName;
  };

  // Delete a blob (path with name): returns true if deleted
  deleteBlobInContainer = async (blobPathWithName) => {
    if (!blobPathWithName) return false;
    const blobService = new BlobServiceClient(
      `${this.context.store.storageBlobUrl}${this.context.store.storageSasToken}`
    );
    const containerClient = blobService.getContainerClient(
      this.context.store.storageBlobContainerName
    );
    const blobClient = containerClient.getBlobClient(blobPathWithName);
    const res = await blobClient.deleteIfExists({ deleteSnapshots: "include" });
    // deleteIfExists returns an object with succeeded boolean inside some SDK versions,
    // but we will interpret HTTP status too:
    try {
      const status = res._response?.status;
      return status >= 200 && status < 300;
    } catch {
      return !!res;
    }
  };

  // Persist filename in DB (server should expose this endpoint)
  persistAttachmentFileName = async (orderId, filename) => {
    if (!orderId) throw new Error("Order id missing");
    const url = this.PERSIST_ATTACHMENT_URL;
    const payload = { id: orderId, attachmentFileName: filename };

    const resp = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Persist failed: ${resp.status} ${text}`);
    }

    return true;
  };

  // remove attachment via UI (delete blob + clear DB reference)
  onDeleteAttachmentClick = async (e) => {
    if (e && e.stopPropagation) e.stopPropagation();

    const filename = this.state.salesOrder?.attachmentFileName;
    if (!filename) return;

    const confirm = await Swal.fire({
      title: "Delete attachment?",
      text: "This will remove the file from blob storage and clear the record.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (!confirm.isConfirmed) return;
    this.ShowLoadSpinner();

    try {
      const deleted = await this.deleteBlobInContainer(`so-orders/${filename}`);
      if (!deleted) {
        Swal.fire(
          "Warning",
          "Failed to delete file from blob storage.",
          "warning"
        );
      } else {
        // clear DB reference
        if (this.state.salesOrder?.id) {
          try {
            await this.persistAttachmentFileName(this.state.salesOrder.id, "");
            Swal.fire("Deleted", "Attachment removed.", "success");
            if (this.props.refresh) this.props.refresh();
          } catch (err) {
            console.error("Failed clearing DB ref", err);
            Swal.fire(
              "Warning",
              "File deleted but clearing DB reference failed.",
              "warning"
            );
          }
        } else {
          Swal.fire("Deleted", "Attachment removed from storage.", "success");
        }
      }
    } catch (err) {
      console.error("onDeleteAttachmentClick err", err);
      Swal.fire("Error", "Failed to delete attachment. See console.", "error");
    } finally {
      this.HideLoadSpinner();
    }
  };

  OnEditButtonClick = () => this.setState({ editModalShow: true });
  editModalClose = () => {
    this.setState({ editModalShow: false }, () => this.props.refresh?.());
  };

  getWarehouseName = () => {
    const so = this.state.salesOrder || {};
    const warehouses = this.props.warehouse || [];
    const w = warehouses.find((x) => String(x.id) === String(so.warehouseId));
    return w ? w.name : "";
  };

  sanitizePhoneNumber(phone) {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    // remove any leading zeros
    return digits.replace(/^0+/, "");
  }

  // return string suitable for wa.me (prefix with country code when needed)
  getWhatsAppNumber(phone) {
    const digits = this.sanitizePhoneNumber(phone);
    if (!digits) return null;

    // If digits already look like they include country code (length > 10), return as-is
    if (digits.length > 10) return digits;

    // if 10 digits, prepend country code - use store countryCode if present, fallback to 91
    const cc = (this.context?.store?.countryCode || "91")
      .toString()
      .replace(/\D/g, "");
    return `${cc}${digits}`;
  }

  render() {
    const so = this.state.salesOrder || {};
    return (
      <>
        <input
          style={{ display: "none" }}
          accept=".png,.jpg,.jpeg,.pdf"
          ref={this.inputFile}
          onChange={this.handleFileChange}
          type="file"
        />

        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        {this.state.editModalShow && (
          <SalesOrderAddOrEditModal
            show={this.state.editModalShow}
            onHide={() => this.setState({ editModalShow: false })}
            salesOrder={so}
            prods={this.props.prods}
            warehouse={this.props.warehouse}
            Type="Edit"
            refresh={this.props.refresh}
            GetsInventories={this.props.GetsInventories}
          />
        )}

        <tr
          className={`align-middle text-center ${
            so.status == 4 ? "text-danger fw-bold" : "text-secondary"
          }`}
          style={{ fontSize: "12px" }}
        >
          <td>{(this.props.index ?? 0) + 1}</td>
          <td>{this.context.GetInDateFormat(new Date(so.created))}</td>
          <td>{so.orderId}</td>
          <td>{so.quotationNo}</td>
          <td>
            {so.customerName} {so.contactNumber || "—"}
            {/* whatsapp link */}
            {(() => {
              const waNum = this.getWhatsAppNumber(so.contactNumber);
              if (!waNum) return null;
              const waUrl = `https://wa.me/${waNum}`;

              return (
                <OverlayTrigger overlay={<Tooltip>Open WhatsApp</Tooltip>}>
                  <a
                    href={waUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-2"
                    style={{ textDecoration: "none" }}
                    title={`WhatsApp ${so.contactNumber}`}
                  >
                    <FaWhatsapp
                      size={18}
                      style={{ color: "#25D366", verticalAlign: "middle" }}
                    />
                  </a>
                </OverlayTrigger>
              );
            })()}
          </td>

          {/* NEW: Warehouse name cell */}
          <td>{this.getWarehouseName()}</td>

          <td>
            {so.paymentStatus == 1
              ? "Paid"
              : so.paymentStatus == 2
              ? "Unpaid"
              : "Partially Paid"}
          </td>
          <td>{so.paidAmount}</td>
          <td>{so.createdBy}</td>
          <td>
            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
              <Button
                className="rounded-circle me-2"
                variant="warning"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ editModalShow: so.id });
                }}
              >
                <BsFillPencilFill size="16" />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>}>
              <Button
                className="rounded-circle"
                variant="danger"
                size="sm"
                onClick={this.handleDelete}
              >
                X
              </Button>
            </OverlayTrigger>
          </td>

          <td>
            {!so.attachmentFileName ? (
              <>
                Attachment (if any): <br />
                <Link
                  className="text-green text-decoration-none"
                  onClick={(e) => {
                    this.onUploadButtonClick(e);
                  }}
                >
                  click to attach
                </Link>
              </>
            ) : (
              <>
                <a
                  href={`${this.context.store.storageBlobUrl}${this.context.store.storageBlobContainerName}/so-orders/${so.attachmentFileName}${this.context.store.storageSasToken}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-green text-decoration-none"
                >
                  Attachment
                </a>
                &nbsp;
                <Button
                  className="bg-green"
                  onClick={this.onDeleteAttachmentClick}
                >
                  X
                </Button>
              </>
            )}
          </td>
        </tr>
      </>
    );
  }
}

export class SalesOrderAddOrEditModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);

    this.state = {
      salesOrder: {
        id: undefined,
        warehouseId: "", // <-- new
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      salesOrderItems: [],
      showOrderItemModal: false,
      editSalesItemRow: null, // null = Add, number = Edit row index
      salesOrderPayments: [], // holds payment objects
      showPaymentModal: false,
      editPaymentRow: null,
    };

    this.printSalesOrder = this.printSalesOrder.bind(this);
  }

  GetPaymentMethodName = (id) => {
    const map = {
      1: "Cash",
      2: "Bank Transfer",
      3: "Cheque",
      4: "UPI",
      5: "Other",
    };
    return map[id] || "Unknown";
  };

  AddPayment = (payment) => {
    this.setState((prev) => ({
      salesOrderPayments: [...(prev.salesOrderPayments || []), { ...payment }],
      showPaymentModal: false,
      editPaymentRow: null,
    }));
  };

  UpdatePayment = (payment, index) => {
    const list = [...(this.state.salesOrderPayments || [])];
    list[index] = { ...list[index], ...payment };
    this.setState({
      salesOrderPayments: list,
      showPaymentModal: false,
      editPaymentRow: null,
    });
  };

  handleRemovePayment = (index) => {
    const list = [...(this.state.salesOrderPayments || [])];
    list.splice(index, 1);
    this.setState({ salesOrderPayments: list });
  };

  GetPaymentsTotal = () =>
    (this.state.salesOrderPayments || []).reduce(
      (s, p) => s + Number(p.amount || 0),
      0
    );

  handleAddPayment = () =>
    this.setState({ showPaymentModal: true, editPaymentRow: null });
  onEditPayment = (idx) =>
    this.setState({ showPaymentModal: true, editPaymentRow: idx });
  onHidePaymentModal = () =>
    this.setState({ showPaymentModal: false, editPaymentRow: null });

  // inject responsive CSS once
  componentDidMount() {
    if (!document.getElementById("ec-salesorder-responsive-css")) {
      const css = `
/* Responsive table -> card view under 768px */
.ec-table-responsive { width:100%; overflow:auto; }
@media (max-width: 767.98px) {
  .ec-responsive-table thead { display: none !important; }
  .ec-responsive-table tbody, .ec-responsive-table tr { display: block; width: 100%; }
  .ec-responsive-table tr { margin-bottom: 12px; border:1px solid #eee; border-radius:6px; padding:8px; background:#fff; }
  .ec-responsive-table td { display: block; padding:6px 8px; border: none; width:100%; box-sizing:border-box; text-align: left; }
  .ec-responsive-table td[data-label]:before {
    content: attr(data-label) ": ";
    font-weight: 700;
    display: inline-block;
    width: 42%;
    vertical-align: top;
  }
  .ec-responsive-table td .btn { display:inline-block; margin-top:6px; }
  .ec-responsive-table .text-end { text-align: left !important; }
  .ec-responsive-table .text-center { text-align: left !important; }
  .ec-responsive-table .bg-secondary { background: transparent !important; color: inherit !important; }
  /* make action buttons full width-ish */
  .ec-responsive-actions { display:flex; gap:8px; flex-wrap:wrap; }
  .ec-responsive-actions .btn { flex: 1 1 auto; min-width: 84px; }
}

/* keep desktop look intact */
.ec-responsive-table td, .ec-responsive-table th { vertical-align: middle; }
`;
      const style = document.createElement("style");
      style.id = "ec-salesorder-responsive-css";
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);
    }

    // if editing an existing order, fetch details
    if (this.props.Type === "Edit" && this.props.salesOrder?.id) {
      this.GetSalesOrderById(this.props.salesOrder.id);
    }
  }

  // -------------------------
  // Helpers
  // -------------------------
  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide && this.props.onHide();
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  // -------------------------
  // API Call - Get SalesOrder By Id
  // -------------------------
  GetSalesOrderById = (id) => {
    fetch(process.env.REACT_APP_API + "SalesOrder/GetSalesOrderById/" + id)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          this.setState({
            salesOrder: data,
            salesOrderItems: data.salesOrderItems || [],
            salesOrderPayments: data.salesOrderPayments || [], // <-- payments from server
          });
        }
      })
      .catch((error) => console.error("Error fetching SalesOrder", error));
  };

  // -------------------------
  // Save (Add / Update)
  // -------------------------
  AddOrUpdateSalesOrderInDB = () => {
    if (
      !this.state.salesOrderItems ||
      this.state.salesOrderItems.length === 0
    ) {
      Swal.fire("Warning", "Please add order items and try!", "warning");
      return;
    }

    this.ShowLoadSpinner();
    let tmp = { ...this.state.salesOrder };

    if (this.props.Type !== "Edit") {
      tmp.storeId = this.context.storeId;
      tmp.createdBy = this.context.userData?.emailId;
    }
    tmp.salesOrderItems = this.state.salesOrderItems;
    tmp.salesOrderPayments = this.state.salesOrderPayments; // <-- include payments

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmp),
    };

    fetch(
      process.env.REACT_APP_API + "SalesOrder/AddOrUpdateSalesOrder",
      requestOptions
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status === 200) {
          if (this.props.refresh) this.props.refresh();
          this.props.onHide && this.props.onHide();
        } else {
          Swal.fire(
            "Error",
            "This SalesOrder already exists or failed!",
            "error"
          );
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        Swal.fire("Error", "Exception: " + error, "error");
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.AddOrUpdateSalesOrderInDB();
  };

  // -------------------------
  // Item Operations
  // -------------------------
  UpdateSalesItem = (item, index) => {
    const list = [...this.state.salesOrderItems];
    list[index] = item;
    this.setState({
      salesOrderItems: list,
      editSalesItemRow: null,
      showOrderItemModal: false,
    });
  };

  AddSalesItem = (item) => {
    this.setState((prev) => ({
      salesOrderItems: [
        ...prev.salesOrderItems,
        { ...item, seqNo: prev.salesOrderItems.length + 1 },
      ],
      showOrderItemModal: false,
    }));
  };

  handleRemoveClick = (index) => {
    const list = [...this.state.salesOrderItems];
    list.splice(index, 1);
    this.setState({ salesOrderItems: list });
  };

  OnEditButtonClick = (i) => {
    this.setState({ editSalesItemRow: i, showOrderItemModal: true });
  };

  // -------------------------
  // Form Field Updates
  // -------------------------
  handleInputChange = (e) => {
    const { name, value } = e.target;
    let so = { ...this.state.salesOrder, [name]: value };
    this.setState({ salesOrder: so });
  };

  // -------------------------
  // Calculations & Product lookup
  // -------------------------
  GetProductFromId = (id) => {
    if (!id) return null;
    const prods = (this.context.prods || []).filter((f) => f.id === id);
    return prods.length > 0 ? prods[0] : null;
  };

  // returns weight in metric tonnes (MT), rounded to 3 decimals
  getWeight = (row, pieces) => {
    const prod = this.GetProductFromId(row.productId);
    if (!prod) return 0;

    // safely convert fields (handles string/number/null)
    const thickness = Number(prod.thickness) || 0; // mm
    const width = Number(prod.width) || 0; // mm
    const length = Number(prod.length) || 0; // mm
    const pcs = Number(pieces || 0) || 0; // count

    // formula: (thickness * width * length * pieces * 7.85) / 1e9
    const wt = (thickness * width * length * pcs * 7.85) / 1e9;

    return Number(wt.toFixed(3));
  };

  // normalize incoming item shapes so the table logic is consistent
  normalizeItem = (row) => {
    // return object with canonical keys: itemName, piecesOrdered, piecesDelivered, qtyOrdered, qtyDelivered, rate, productId, notes
    return {
      itemName: row.itemName || row.productName || row.name || "",
      piecesOrdered:
        row.piecesOrdered !== undefined ? Number(row.piecesOrdered) : undefined,
      piecesDelivered:
        row.piecesDelivered !== undefined
          ? Number(row.piecesDelivered)
          : undefined,
      qtyOrdered:
        row.qtyOrdered !== undefined ? Number(row.qtyOrdered) : undefined,
      qtyDelivered:
        row.qtyDelivered !== undefined ? Number(row.qtyDelivered) : undefined,
      rate: Number(row.rate || row.price || 0),
      productId: row.productId || row.productId,
      notes: row.notes || "",
      // preserve original fields for downstream updates
      __raw: row,
    };
  };

  // calculate totals for all columns
  getTotals = (items) => {
    const totals = {
      piecesOrdered: 0,
      mtOrdered: 0,
      value: 0,
      piecesDelivered: 0,
      mtDelivered: 0,
      piecesPending: 0,
      mtPending: 0,
    };

    (items || []).forEach((rawRow) => {
      const row = this.normalizeItem(rawRow);
      const po = Number(row.piecesOrdered ?? row.qtyOrdered ?? 0);
      const pd = Number(row.piecesDelivered ?? row.qtyDelivered ?? 0);
      const rate = Number(row.rate || 0);

      const mtO = this.getWeight(row, po);
      const mtD = this.getWeight(row, pd);

      totals.piecesOrdered += po;
      totals.mtOrdered += mtO;
      totals.value += rate * po;
      totals.piecesDelivered += pd;
      totals.mtDelivered += mtD;
      totals.piecesPending += po - pd;
      totals.mtPending += mtO - mtD;
    });

    // normalize to fixed decimals for MT totals
    totals.mtOrdered = Number(totals.mtOrdered.toFixed(3));
    totals.mtDelivered = Number(totals.mtDelivered.toFixed(3));
    totals.mtPending = Number(totals.mtPending.toFixed(3));
    totals.value = Number(totals.value.toFixed(2));

    return totals;
  };

  GetTotalOfSalesOrder = (items) =>
    (items || []).reduce(
      (sum, v) =>
        sum +
        Number(v.rate || 0) * Number(v.piecesOrdered ?? v.qtyOrdered ?? 0),
      0
    );

  // Format helpers
  formatCurrency = (value) => {
    const locale = this.context.storeSettings?.defaultLocale || "en-IN";
    const currency = this.context.storeSettings?.defaultCurrency || "INR";
    try {
      return Number(value || 0).toLocaleString(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch {
      return Number(value || 0).toFixed(2);
    }
  };

  formatNumber = (value, decimals = 2) => {
    const locale = this.context.storeSettings?.defaultLocale || "en-IN";
    try {
      return Number(value || 0).toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    } catch {
      return Number(value || 0).toFixed(decimals);
    }
  };

  printSalesOrder() {
    try {
      const { salesOrder, salesOrderItems } = this.state;
      const totals = this.getTotals(salesOrderItems || []);
      const grand = this.GetTotalOfSalesOrder(salesOrderItems || []);
      const storeName = this.context.storeSettings?.StoreName || "";
      const storeContact = this.context.storeSettings?.StorePhoneNo || "";
      const storeEmail = this.context.storeSettings?.StoreEmailId || "";
      const storeAddress =
        this.context.storeSettings?.StoreAddress ||
        "" ||
        this.context.store?.storageBlobContainerName ||
        "";

      // build rowsHtml synchronously
      const rowsHtml = (salesOrderItems || [])
        .map((r, idx) => {
          const itemName = r.itemName || "";
          const po = Number(r.piecesOrdered || 0);
          const mtO = this.getWeight(r, po);
          const rate = Number(r.rate || 0);
          const lineTotal = rate * po;
          const pd = Number(r.piecesDelivered || 0);
          const mtD = this.getWeight(r, pd);
          const pendingPc = po - pd;
          const pendingMt = mtO - mtD;

          return `<tr>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${
            idx + 1
          }</td>
          <td style="padding:8px;border:1px solid #ccc">${this.escapeHtml(
            itemName
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${this.formatNumber(
            po,
            0
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${this.formatNumber(
            mtO,
            3
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:right">${this.formatCurrency(
            rate
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:right">${this.formatCurrency(
            lineTotal
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${this.formatNumber(
            pd,
            0
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${this.formatNumber(
            mtD,
            3
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${this.formatNumber(
            pendingPc,
            0
          )}</td>
          <td style="padding:8px;border:1px solid #ccc;text-align:center">${this.formatNumber(
            pendingMt,
            3
          )}</td>
          <td style="padding:8px;border:1px solid #ccc">${this.escapeHtml(
            r.notes || ""
          )}</td>
        </tr>`;
        })
        .join("");

      const invoiceHtml = `<!doctype html><html><head><meta charset="utf-8"/><title>Sales Order - ${this.escapeHtml(
        salesOrder.orderId || salesOrder.id || ""
      )}</title><style>
      body{font-family: Arial, Helvetica, sans-serif; color:#222; margin:20px}
      .header{display:flex;justify-content:space-between;align-items:center}
      .store{font-size:18px;font-weight:700}
      .meta{font-size:13px}
      table{width:100%;border-collapse:collapse;margin-top:12px}
      th{background:#f4f4f4;padding:8px;border:1px solid #ddd}
      td{padding:6px;border:1px solid #ddd}
      .right{text-align:right}
      .center{text-align:center}
      .totals td{font-weight:700;background:#fafafa}
      .notes{margin-top:12px}
    </style></head><body>
      <div class="header">
        <div>
          <div class="store">${this.escapeHtml(storeName)}</div>
          <div class="meta">${this.escapeHtml(storeAddress)}</div>
          <div class="meta">Phone: ${this.escapeHtml(storeContact || "")} ${
        storeEmail ? " | Email: " + this.escapeHtml(storeEmail) : ""
      }</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:16px;font-weight:700">Sales Order</div>
          <div style="margin-top:8px">Order#: <b>${this.escapeHtml(
            salesOrder.orderId || salesOrder.id || ""
          )}</b></div>
          <div>Date: <b>${this.escapeHtml(
            salesOrder.created
              ? new Date(salesOrder.created).toLocaleString()
              : new Date().toLocaleString()
          )}</b></div>
          <div>Warehouse: <b>${this.escapeHtml(
            (this.props.warehouse || []).find(
              (w) => String(w.id) === String(salesOrder.warehouseId)
            )?.name ||
              salesOrder.warehouseName ||
              "" ||
              ""
          )}</b></div>
        </div>
      </div>

      <div style="margin-top:14px">
        <strong>Customer:</strong> ${this.escapeHtml(
          salesOrder.customerName || ""
        )} <br/>
        <strong>Contact:</strong> ${this.escapeHtml(
          salesOrder.contactNumber || ""
        )} <br/>
        <strong>Address:</strong> ${this.escapeHtml(salesOrder.address || "")}
      </div>

      <table>
        <thead>
          <tr>
            <th style="width:30px">#</th>
            <th>Item</th>
            <th style="width:80px">PC (Ordered)</th>
            <th style="width:90px">MT (Ordered)</th>
            <th style="width:110px">Rate/Unit</th>
            <th style="width:110px">Total</th>
            <th style="width:80px">PC (Delivered)</th>
            <th style="width:90px">MT (Delivered)</th>
            <th style="width:80px">PC Pending</th>
            <th style="width:90px">MT Pending</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr class="totals">
            <td colspan="2" style="text-align:right">Totals:</td>
            <td class="center">${this.formatNumber(
              totals.piecesOrdered,
              0
            )}</td>
            <td class="center">${this.formatNumber(totals.mtOrdered, 3)}</td>
            <td></td>
            <td class="right">${this.formatCurrency(totals.value)}</td>
            <td class="center">${this.formatNumber(
              totals.piecesDelivered,
              0
            )}</td>
            <td class="center">${this.formatNumber(totals.mtDelivered, 3)}</td>
            <td class="center">${this.formatNumber(
              totals.piecesPending,
              0
            )}</td>
            <td class="center">${this.formatNumber(totals.mtPending, 3)}</td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top:18px; text-align:right; font-size:16px">
        <div>Grand Total: <strong>${this.formatCurrency(grand)}</strong></div>
      </div>

      ${
        salesOrder.remarks
          ? `<div class="notes"><strong>Remarks:</strong><div>${this.nl2br(
              this.escapeHtml(salesOrder.remarks)
            )}</div></div>`
          : ""
      }

      <div style="margin-top:24px; font-size:12px; color:#666">Generated by ElasticCart</div>
    </body></html>`;

      // --- OPEN SYNCHRONOUS WINDOW FIRST ---
      const printWindow = window.open("", "_blank", "noopener,noreferrer");
      if (!printWindow) {
        // popup blocked — show friendly message and offer to download the HTML
        Swal.fire({
          title: "Popup blocked",
          html:
            "Your browser blocked opening a new window for printing. <br/><br/>" +
            "Please allow popups for this site or choose to download the invoice HTML and open it manually.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Download HTML",
          cancelButtonText: "Ok",
        }).then((res) => {
          if (res.isConfirmed) {
            // create blob and download
            const blob = new Blob([invoiceHtml], { type: "text/html" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `salesorder-${
              salesOrder.orderId || salesOrder.id || "invoice"
            }.html`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 2000);
          }
        });
        return;
      }

      // write a lightweight loading page so user sees something immediately
      try {
        printWindow.document.open();
        printWindow.document.write(
          "<!doctype html><html><head><title>Loading...</title></head><body><div style='font-family:Arial;padding:20px'>Preparing printable sales order...</div></body></html>"
        );
        printWindow.document.close();
      } catch (err) {
        // If we can't write (cross-origin weirdness), close and fallback
        printWindow.close();
        Swal.fire(
          "Error",
          "Unable to open print window. Please allow popups.",
          "error"
        );
        return;
      }

      // now populate with full HTML and trigger print (kept inside setTimeout to allow render)
      setTimeout(() => {
        try {
          printWindow.document.open();
          printWindow.document.write(invoiceHtml);
          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
          // keep window open so user can save as PDF; close automatically if you prefer:
          // printWindow.close();
        } catch (err) {
          console.error("Print flow failed", err);
          Swal.fire("Error", "Print failed. See console for details.", "error");
        }
      }, 250);
    } catch (err) {
      console.error("printSalesOrder error", err);
      Swal.fire("Error", "Unable to print sales order. See console.", "error");
    }
  }

  // small helpers for safe HTML (used in print)
  escapeHtml(str) {
    if (str === null || str === undefined) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  nl2br(str) {
    if (!str) return "";
    return String(str).replace(/\r\n|\n\r|\r|\n/g, "<br/>");
  }

  // -------------------------
  // RENDER
  // -------------------------
  render() {
    const { salesOrder, salesOrderItems } = this.state;
    const isSteel =
      !!this.context.isSteelTraders && this.context.isSteelTraders();

    const grandTotal = this.GetTotalOfSalesOrder(salesOrderItems);
    const totals = this.getTotals(salesOrderItems || []);

    return (
      <div className="container">
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="SalesOrderModal"
        >
          {this.state.msgboxOpen && (
            <div className="mb-2 text-center text-danger">
              {this.state.msgboxMessage}
            </div>
          )}
          {this.state.loadSpinnerOpen && <div>Loading...</div>}

          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-primary text-white">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type === "Edit"
                  ? `Edit Sales Order ${
                      this.state.salesOrder.orderId
                        ? "(" + this.state.salesOrder.orderId + ")"
                        : ""
                    }`
                  : `Add Sales Order`}
              </Modal.Title>

              <div style={{ marginLeft: "auto", paddingRight: 12 }}>
                <Button
                  size="sm"
                  variant="outline-light"
                  onClick={this.printSalesOrder}
                  title="Print Sales Order"
                >
                  <i className="fa fa-print" /> Print
                </Button>
              </div>
            </Modal.Header>
            <Modal.Body>
              {this.state.showOrderItemModal && (
                <AddOrEditSalesOrderItem
                  show={true}
                  Type={this.state.editSalesItemRow !== null ? "Edit" : "Add"}
                  salesOrderItem={
                    this.state.salesOrderItems[this.state.editSalesItemRow]
                  }
                  Index={this.state.editSalesItemRow}
                  onHide={() =>
                    this.setState({
                      showOrderItemModal: false,
                      editSalesItemRow: null,
                    })
                  }
                  AddSalesItem={this.AddSalesItem}
                  UpdateSalesItem={this.UpdateSalesItem}
                  prods={this.props.prods}
                  warehouse={this.props.warehouse}
                  GetsInventories={this.props.GetsInventories}
                  fixedWarehouseId={salesOrder.warehouseId} // keep warehouse binding
                />
              )}

              {/* Customer Details */}
              <div className="p-2 bg-light rounded">
                <Row>
                  <Col md={3}>
                    <FloatingLabel label="Warehouse" className="mb-3">
                      <Form.Select
                        name="warehouseId"
                        value={salesOrder.warehouseId || ""}
                        onChange={this.handleInputChange}
                      >
                        <option value="">-- Select Warehouse --</option>
                        {(this.props.warehouse || []).map((w) => (
                          <option key={w.id} value={String(w.id)}>
                            {w.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={3}>
                    <FloatingLabel label="Customer Name*" className="mb-3">
                      <Form.Control
                        type="text"
                        name="customerName"
                        value={salesOrder.customerName || ""}
                        required
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={3}>
                    <FloatingLabel label="Contact Number" className="mb-3">
                      <Form.Control
                        type="text"
                        name="contactNumber"
                        value={salesOrder.contactNumber || ""}
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={3}>
                    <FloatingLabel label="Email Id" className="mb-3">
                      <Form.Control
                        type="email"
                        name="emailId"
                        value={salesOrder.emailId || ""}
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FloatingLabel label="Address" className="mb-3">
                      <Form.Control
                        type="text"
                        name="address"
                        value={salesOrder.address || ""}
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Quotation No" className="mb-3">
                      <Form.Control
                        type="text"
                        name="quotationNo"
                        value={salesOrder.quotationNo || ""}
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>

                  <Col md={2}>
                    <FloatingLabel label="Order Status*" className="mb-3">
                      <Form.Select
                        name="status"
                        value={salesOrder.status || 1}
                        onChange={this.handleInputChange}
                      >
                        <option value={1}>New Order</option>
                        <option value={2}>Partially Delivered</option>
                        <option value={3}>Delivered</option>
                        <option value={4}>Cancelled</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Payment Status*" className="mb-3">
                      <Form.Select
                        name="paymentStatus"
                        value={salesOrder.paymentStatus || ""}
                        required
                        onChange={this.handleInputChange}
                      >
                        <option value="">-- Select --</option>
                        <option value={1}>Paid</option>
                        <option value={2}>Unpaid</option>
                        <option value={3}>Partially Paid</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  {/* <Col md={2}>
                    <FloatingLabel label="Paid Amount" className="mb-3">
                      <Form.Control
                        type="number"
                        name="paidAmount"
                        value={salesOrder.paidAmount || ""}
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col> */}
                </Row>
                <Row>
                  <Col md={12} className="mt-2">
                    <Form.Group>
                      <Form.Label>Remarks</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="remarks"
                        rows={3}
                        maxLength={1999}
                        value={salesOrder.remarks || ""}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Items */}
              <div className="my-3 bg-light rounded p-2">
                <Row>
                  <Col md={8}>
                    <h5>Sales Order Items *</h5>
                  </Col>
                  <Col md={4} className="text-end">
                    <Button
                      variant="primary"
                      size="sm"
                      disabled={!salesOrder.warehouseId}
                      onClick={() => {
                        if (!salesOrder.warehouseId) {
                          Swal.fire(
                            "Warning",
                            "Please select a warehouse before adding items.",
                            "warning"
                          );
                          return;
                        }
                        this.setState({
                          showOrderItemModal: true,
                          editSalesItemRow: null,
                        });
                      }}
                    >
                      + Add Item
                    </Button>
                  </Col>
                </Row>

                <div className="ec-table-responsive">
                  <Table
                    bordered
                    striped
                    className="mt-2 ec-responsive-table"
                    style={{ fontSize: "13px" }}
                  >
                    {isSteel ? (
                      <>
                        <thead className="bg-secondary text-white text-center">
                          <tr>
                            <th>#</th>
                            <th style={{ textAlign: "start" }}>Item</th>
                            <th>PC (Ordered) (A)</th>
                            <th>MT (Ordered) (B)</th>
                            <th>Rate/Unit(approx)</th>
                            <th>Total(approx)</th>
                            <th>PC (Delivered) (C)</th>
                            <th>MT (Delivered) (D)</th>
                            <th>PC Pending (A-C)</th>
                            <th>MT Pending (B-D)</th>
                            <th style={{ textAlign: "start" }}>Notes</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {salesOrderItems.map((row, i) => {
                            const r = this.normalizeItem(row);
                            const po = Number(r.piecesOrdered || 0);
                            const pd = Number(r.piecesDelivered || 0);
                            const mtO = this.getWeight(r, po);
                            const mtD = this.getWeight(r, pd);
                            return (
                              <tr key={i}>
                                <td data-label="#"> {i + 1} </td>
                                <td
                                  data-label="Item"
                                  style={{ textAlign: "start" }}
                                >
                                  {r.itemName}
                                </td>
                                <td data-label="PC (Ordered)">{po}</td>
                                <td data-label="MT (Ordered)">{mtO}</td>
                                <td data-label="Rate/Unit">
                                  {this.formatCurrency(r.rate)}
                                </td>
                                <td data-label="Total">
                                  {this.formatCurrency((r.rate || 0) * po)}
                                </td>
                                <td data-label="PC (Delivered)">{pd}</td>
                                <td data-label="MT (Delivered)">{mtD}</td>
                                <td data-label="PC Pending">{po - pd}</td>
                                <td data-label="MT Pending">
                                  {this.formatNumber(mtO - mtD, 3)}
                                </td>
                                <td
                                  data-label="Notes"
                                  style={{ textAlign: "start" }}
                                >
                                  {r.notes}
                                </td>
                                <td data-label="Options">
                                  <div className="ec-responsive-actions">
                                    <Button
                                      size="sm"
                                      variant="warning"
                                      onClick={() => this.OnEditButtonClick(i)}
                                    >
                                      <BsFillPencilFill size="16" />
                                    </Button>
                                    <Button
                                      size="sm"
                                      variant="danger"
                                      onClick={() => this.handleRemoveClick(i)}
                                    >
                                      X
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}

                          <tr className="fw-bold bg-light text-center">
                            <td colSpan={2} className="text-end">
                              Totals:
                            </td>
                            <td data-label="Total PC">
                              {Number(totals.piecesOrdered || 0)}
                            </td>
                            <td data-label="Total MT">
                              {this.formatNumber(totals.mtOrdered, 3)}
                            </td>
                            <td></td>
                            <td data-label="Value">
                              {this.formatCurrency(totals.value)}
                            </td>
                            <td data-label="PC Delivered">
                              {Number(totals.piecesDelivered || 0)}
                            </td>
                            <td data-label="MT Delivered">
                              {this.formatNumber(totals.mtDelivered, 3)}
                            </td>
                            <td data-label="PC Pending">
                              {Number(totals.piecesPending || 0)}
                            </td>
                            <td data-label="MT Pending">
                              {this.formatNumber(totals.mtPending, 3)}
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </>
                    ) : (
                      <>
                        <thead className="bg-secondary text-white">
                          <tr>
                            <th>#</th>
                            <th style={{ textAlign: "start" }}>Item</th>
                            <th>Ordered Qty/Wt (A)</th>
                            <th>Rate/Unit(approx)</th>
                            <th>Total(approx)</th>
                            <th>Delivered Qty/Wt (B)</th>
                            <th>A-B</th>
                            <th style={{ textAlign: "start" }}>Notes</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {salesOrderItems.map((row, i) => {
                            const r = this.normalizeItem(row);
                            const ordered = Number(r.qtyOrdered ?? 0);
                            const delivered = Number(r.qtyDelivered ?? 0);
                            return (
                              <tr key={i}>
                                <td data-label="#">{i + 1}</td>
                                <td
                                  data-label="Item"
                                  style={{ textAlign: "start" }}
                                >
                                  {r.itemName}
                                </td>
                                <td data-label="Ordered">{ordered}</td>
                                <td data-label="Rate">
                                  {this.formatCurrency(r.rate)}
                                </td>
                                <td data-label="Total">
                                  {this.formatCurrency((r.rate || 0) * ordered)}
                                </td>
                                <td data-label="Delivered">{delivered}</td>
                                <td data-label="Pending">
                                  {ordered - delivered}
                                </td>
                                <td
                                  data-label="Notes"
                                  style={{ textAlign: "start" }}
                                >
                                  {r.notes}
                                </td>
                                <td data-label="Options">
                                  <div className="ec-responsive-actions">
                                    <Button
                                      size="sm"
                                      variant="warning"
                                      onClick={() => this.OnEditButtonClick(i)}
                                    >
                                      <BsFillPencilFill size="16" />
                                    </Button>
                                    <Button
                                      size="sm"
                                      variant="danger"
                                      onClick={() => this.handleRemoveClick(i)}
                                    >
                                      X
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}

                          <tr className="fw-bold bg-light">
                            <td colSpan={2} className="text-end">
                              Totals:
                            </td>
                            <td data-label="Total Ordered">
                              {Number(totals.piecesOrdered || 0)}
                            </td>
                            <td></td>
                            <td data-label="Value">
                              {this.formatCurrency(totals.value)}
                            </td>
                            <td data-label="Delivered">
                              {Number(totals.piecesDelivered || 0)}
                            </td>
                            <td data-label="Pending">
                              {Number(totals.piecesPending || 0)}
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </>
                    )}
                  </Table>
                </div>
              </div>

              {/* Payments block */}
              <div className="my-3 bg-light rounded p-2">
                <Row>
                  <Col md={8}>
                    <h5>Payments</h5>
                  </Col>
                  <Col md={4} className="text-end">
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={this.handleAddPayment}
                    >
                      + Add Payment
                    </Button>
                  </Col>
                </Row>

                {this.state.showPaymentModal && (
                  <AddOrEditSalesOrderPayment
                    show={true}
                    onHide={this.onHidePaymentModal}
                    AddPayment={this.AddPayment}
                    UpdatePayment={this.UpdatePayment}
                    Type={this.state.editPaymentRow !== null ? "Edit" : "Add"}
                    payment={
                      this.state.salesOrderPayments[this.state.editPaymentRow]
                    }
                    Index={this.state.editPaymentRow}
                    GetPaymentMethodName={this.GetPaymentMethodName}
                  />
                )}

                <div className="table-responsive mt-2">
                  <Table bordered size="sm">
                    <thead className="bg-secondary text-white text-center">
                      <tr>
                        <th>#</th>
                        <th>Date</th>
                        <th>Method</th>
                        <th>Txn/Ref</th>
                        <th>Amount</th>
                        <th>Notes</th>
                        <th>Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(this.state.salesOrderPayments || []).map((p, idx) => (
                        <tr
                          key={p.id || idx}
                          className="align-middle text-center"
                        >
                          <td>{idx + 1}</td>
                          <td>
                            {p.paymentDate
                              ? new Date(p.paymentDate)
                                  .toISOString()
                                  .split("T")[0]
                              : ""}
                          </td>
                          <td>{this.GetPaymentMethodName(p.paymentMethod)}</td>
                          <td>{p.paymentTransactionId}</td>
                          <td className="text-end">
                            {this.formatCurrency(p.amount)}
                          </td>
                          <td className="text-start">{p.notes}</td>
                          <td>
                            <Button
                              size="sm"
                              variant="warning"
                              onClick={() => this.onEditPayment(idx)}
                            >
                              Edit
                            </Button>{" "}
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => this.handleRemovePayment(idx)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}

                      <tr className="fw-bold bg-light">
                        <td colSpan={4} className="text-end">
                          Total Paid
                        </td>
                        <td className="text-end">
                          {this.formatCurrency(this.GetPaymentsTotal())}
                        </td>
                        <td colSpan={2}></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                size="lg"
                type="submit"
                disabled={!salesOrderItems || salesOrderItems.length === 0}
              >
                Save
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={() => this.props.onHide && this.props.onHide()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

/* ---------------------------------------------------------------------
   AddOrEditSalesOrderItem (updated to accept fixedWarehouseId prop).
   - If fixedWarehouseId passed: the warehouse select is read-only (disabled)
   - It still filters products by warehouseId and disables "New Product?" if no warehouse
   --------------------------------------------------------------------- */
export class AddOrEditSalesOrderItem extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      warehouseId: "", // string
      productId: "",

      itemName: "",
      unit: "",

      piecesOrdered: 1,
      piecesDelivered: 0,
      qtyOrdered: 1,
      qtyDelivered: 0,
      rate: 0,
      notes: "",

      productNames: [],
      prodsFiltered: [],
      addModalShow: false,
    };
  }

  // -------------------------
  // Helpers (camelCase only)
  // -------------------------
  idStr = (v) => (v === undefined || v === null ? "" : String(v));

  getProductLabel = (p) => {
    let result = p.name || "";
    if (p.batchId) result += " BatchId:" + p.batchId;
    if (p.remarks) result += " " + p.remarks;
    return result.trim();
  };

  deriveWarehouseIdFromProds = (productId) => {
    const list = Array.isArray(this.props.prods) ? this.props.prods : [];
    const prod = list.find((x) => this.idStr(x.id) === this.idStr(productId));
    return this.idStr(prod?.warehouseId);
  };

  loadProductsByWarehouse = () => {
    const wid = this.state.warehouseId;
    if (!wid) {
      this.setState({ productNames: [], prodsFiltered: [] });
      return;
    }

    const list = Array.isArray(this.props.prods) ? this.props.prods : [];
    const filtered = list
      .filter((p) => this.idStr(p.warehouseId) === this.idStr(wid))
      .map((p) => ({
        id: this.idStr(p.id),
        name: p.name || "",
        unit: p.unit || "",
        warehouseId: this.idStr(p.warehouseId),
        batchId: p.batchId,
        remarks: p.remarks,
        thickness: p.thickness,
        width: p.width,
        length: p.length,
      }));

    const options = filtered.map((p) => ({
      value: p.id,
      label: this.getProductLabel(p),
    }));

    this.setState({
      prodsFiltered: filtered,
      productNames: options.sort((a, b) =>
        a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1
      ),
    });
  };

  onProductChange = (e) => {
    const prd = this.state.prodsFiltered.find(
      (p) => p.id === this.idStr(e?.value)
    );
    if (prd) {
      this.setState({
        productId: prd.id,
        itemName: prd.name,
        unit: prd.unit,
      });
    } else {
      this.setState({ productId: "", itemName: "", unit: "" });
    }
  };

  GetProductFromId = (id) => {
    var prods = this.context.prods.filter((f) => f.id === id);
    if (prods.length > 0) return prods[0];

    return null;
  };

  getWeight = (pieces) => {
    const prod = this.GetProductFromId(this.state.productId);
    if (!prod) return 0;

    const thickness = Number(prod.thickness) || 0; // mm
    const width = Number(prod.width) || 0; // mm
    const length = Number(prod.length) || 0; // mm
    const pcs = Number(pieces || 0) || 0; // count

    const wt = (thickness * width * length * pcs * 7.85) / 1e9;

    return Number(wt.toFixed(3));
  };

  GetOrderedWeight = () => {
    return this.getWeight(this.state.piecesOrdered);
  };

  GetDeliveredWeight = () => {
    return this.getWeight(this.state.piecesDelivered);
  };

  // -------------------------
  // Lifecycle
  // -------------------------
  componentDidMount() {
    // if parent enforces a fixed warehouse, apply it
    if (this.props.fixedWarehouseId) {
      this.setState(
        { warehouseId: this.idStr(this.props.fixedWarehouseId) },
        this.loadProductsByWarehouse
      );
    }

    if (this.props.Type === "Edit" && this.props.salesOrderItem) {
      const it = this.props.salesOrderItem;
      const productId = this.idStr(it.productId ?? it.id);
      const derivedWid = this.deriveWarehouseIdFromProds(productId);

      this.setState(
        {
          warehouseId: this.idStr(it.warehouseId ?? derivedWid),
          productId,
          itemName: it.itemName || it.name || "",
          unit: it.unit || "",
          qtyOrdered: it.qtyOrdered ?? 1,
          qtyDelivered: it.qtyDelivered ?? 0,
          piecesOrdered: it.piecesOrdered ?? 1,
          piecesDelivered: it.piecesDelivered ?? 0,
          rate: it.rate ?? 0,
          notes: it.notes ?? "",
        },
        this.loadProductsByWarehouse
      );
    }
  }

  componentDidUpdate(prevProps) {
    // If parent changed fixedWarehouseId (unlikely), update
    if (this.props.fixedWarehouseId !== prevProps.fixedWarehouseId) {
      this.setState(
        {
          warehouseId: this.idStr(this.props.fixedWarehouseId),
          productId: "",
          itemName: "",
        },
        this.loadProductsByWarehouse
      );
    }

    // Edit row changed → re-derive from prods
    if (
      this.props.Type === "Edit" &&
      this.props.salesOrderItem &&
      this.props.salesOrderItem !== prevProps.salesOrderItem
    ) {
      const it = this.props.salesOrderItem;
      const productId = this.idStr(it.productId ?? it.id);
      const derivedWid = this.deriveWarehouseIdFromProds(productId);

      this.setState(
        {
          warehouseId: this.idStr(it.warehouseId ?? derivedWid),
          productId,
          itemName: it.itemName || it.name || "",
          unit: it.unit || "",
          qtyOrdered: it.qtyOrdered ?? 1,
          qtyDelivered: it.qtyDelivered ?? 0,
          piecesOrdered: it.piecesOrdered ?? 1,
          piecesDelivered: it.piecesDelivered ?? 0,
          rate: it.rate ?? 0,
          notes: it.notes ?? "",
        },
        this.loadProductsByWarehouse
      );
    }

    if (this.props.prods !== prevProps.prods && this.state.warehouseId) {
      this.loadProductsByWarehouse();
    }

    if (
      this.props.warehouse !== prevProps.warehouse &&
      this.state.warehouseId
    ) {
      this.loadProductsByWarehouse();
    }
  }

  // -------------------------
  // Form Handlers
  // -------------------------
  handleInputChange = (e) => {
    const { name, value } = e.target;

    const numeric = [
      "qtyOrdered",
      "qtyDelivered",
      "piecesOrdered",
      "piecesDelivered",
      "rate",
      "unit",
    ];
    const v = numeric.includes(name) ? (value === "" ? "" : value) : value;

    // if parent fixedWarehouseId is provided, prevent changing warehouse
    if (name === "warehouseId" && this.props.fixedWarehouseId) {
      // ignore user input and keep fixed
      return;
    }

    this.setState({ [name]: v }, () => {
      if (name === "warehouseId") {
        // reset selected product when warehouse changes
        this.setState(
          { productId: "", itemName: "", unit: "" },
          this.loadProductsByWarehouse
        );
      }
    });
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {
      this.props.GetsInventories?.();
      this.loadProductsByWarehouse();
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.state.productId) {
      Swal.fire({
        title: "Warning",
        text: "Product Name is mandatory!",
        timer: 3000,
      });
      return;
    }

    // ensure warehouseId is set (prefer fixed from parent)
    const finalWarehouseId = this.props.fixedWarehouseId
      ? String(this.props.fixedWarehouseId)
      : this.state.warehouseId;

    const item = {
      warehouseId: finalWarehouseId,
      productId: this.state.productId,
      itemName: this.state.itemName,
      unit: this.state.unit,
      qtyOrdered: Number(this.state.qtyOrdered) || 0,
      qtyDelivered: Number(this.state.qtyDelivered) || 0,
      piecesOrdered: Number(this.state.piecesOrdered) || 0,
      piecesDelivered: Number(this.state.piecesDelivered) || 0,
      rate: Number(this.state.rate) || 0,
      notes: this.state.notes,
    };

    if (this.props.Type === "Add") {
      this.props.AddSalesItem(item);
    } else {
      this.props.UpdateSalesItem(item, this.props.Index);
    }
    this.props.onHide();
  };

  // -------------------------
  // Render
  // -------------------------
  render() {
    const lineTotal =
      (Number(this.state.piecesOrdered) || 0) * (Number(this.state.rate) || 0);

    // If parent passed fixedWarehouseId, show it in select but disable changing
    const fixedWid = this.props.fixedWarehouseId
      ? String(this.props.fixedWarehouseId)
      : null;

    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header closeButton className="bg-warning">
            <Modal.Title>
              {this.props.Type === "Edit"
                ? "Edit Sales Order Item"
                : "Add Sales Order Item"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.addModalShow && (
              <InventoryAddOrEditModal
                show={this.state.addModalShow}
                Type="Add"
                onHide={this.addModalClose}
                GetsInventories={this.props.GetsInventories}
                warehouse={this.props.warehouse}
                warehouseId={this.state.warehouseId}
              />
            )}

            {/* Warehouse */}
            <Row>
              <Col md={9}>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="3">
                    Warehouse *
                  </Form.Label>
                  <Col sm="9">
                    <Form.Select
                      name="warehouseId"
                      value={this.state.warehouseId || ""}
                      onChange={this.handleInputChange}
                      required
                      disabled={!!fixedWid} // readonly if fixed
                    >
                      <option value="">-- Select Warehouse --</option>
                      {(this.props.warehouse || []).map((w) => (
                        <option key={w.id} value={String(w.id)}>
                          {w.name}
                        </option>
                      ))}
                    </Form.Select>
                    {fixedWid && (
                      <div className="small text-muted mt-1">
                        Warehouse is fixed for this order.
                      </div>
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>

            {/* Product */}
            <Row>
              <Col md={9}>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="3">
                    Product *
                  </Form.Label>
                  <Col sm="9">
                    <Select
                      key={this.state.warehouseId || "no-warehouse"}
                      name="productId"
                      placeholder="-- Select Product --"
                      value={
                        this.state.productId
                          ? {
                              value: String(this.state.productId),
                              label: this.state.itemName,
                            }
                          : null
                      }
                      onChange={this.onProductChange}
                      options={this.state.productNames}
                      isDisabled={!this.state.warehouseId}
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Col sm="3" className="d-flex align-items-start">
                <Button
                  size="lg"
                  disabled={!this.state.warehouseId}
                  onClick={() => this.setState({ addModalShow: true })}
                >
                  {!this.state.warehouseId
                    ? "Select Warehouse First"
                    : "New Product ?"}
                </Button>
              </Col>
            </Row>

            {/* Pieces & Qty (Ordered / Delivered) */}
            {this.context.isSteelTraders() ? (
              <>
                <Row>
                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Piece (Ordered)</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="1"
                        name="piecesOrdered"
                        value={this.state.piecesOrdered}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>MT (Ordered)</Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        value={this.GetOrderedWeight()}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Rate/MT *</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="any"
                        name="rate"
                        value={this.state.rate}
                        onChange={this.handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Total Cost(approx)</Form.Label>
                      <Form.Control
                        value={isNaN(lineTotal) ? 0 : lineTotal}
                        disabled
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <hr></hr>
                <Row>
                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Pieces (Delivered)</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="1"
                        name="piecesDelivered"
                        value={this.state.piecesDelivered}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>MT (Delivered)</Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        value={this.GetDeliveredWeight()}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Qty(Ordered)</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="1"
                        name="qtyOrdered"
                        value={this.state.qtyOrdered}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Rate/Qty *</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="any"
                        name="rate"
                        value={this.state.rate}
                        onChange={this.handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Total(approx)</Form.Label>
                      <Form.Control
                        value={isNaN(lineTotal) ? 0 : lineTotal}
                        disabled
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Qty(Delivered)</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="1"
                        name="qtyDelivered"
                        value={this.state.qtyDelivered}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Notes</Form.Label>
                  <Form.Control
                    type="text"
                    name="notes"
                    value={this.state.notes}
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button type="submit">
              {this.props.Type === "Edit" ? "Save" : "Add"}
            </Button>
            <Button variant="danger" onClick={this.props.onHide}>
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export class InventoryAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      product: {
        name: "",
        pieces: 1,
        productVariantType: 1,
        unit: "piece",
        hsnCode: "",
        batchId: "",
        qualityId: "",
        subCategoryId: "",
      },
      mainCategoryId: "",
    };
  }

  AddProductInDB = () => {
    var tmpproduct = this.state.product;
    tmpproduct.storeId = this.context.storeId;

    if (
      this.context.store.businessTypeId ==
      this.context.BusinessTypes.STEELTRADERS
    ) {
      tmpproduct.name =
        tmpproduct.name.trim() +
        " " +
        tmpproduct.thickness +
        "mm X " +
        tmpproduct.width +
        "mm X " +
        tmpproduct.length +
        "mm";
    }

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpproduct),
    };

    fetch(
      process.env.REACT_APP_API + "StoreManager/AddOrUpdateProduct/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.props.GetsInventories();
          this.context.GetAllProducts();
          this.props.onHide();
          return;
        }
        alert("This product is already exist. try again!");
        return;
      })
      .catch((error) => {
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "name":
        this.state.product.name = value;
        break;
      case "productVariantType":
        this.state.product.productVariantType = value;
        break;
      case "thickness":
        this.state.product.thickness = value;
        break;
      case "width":
        this.state.product.width = value;
        break;
      case "length":
        this.state.product.length = value;
        break;
      case "pieces":
        this.state.product.pieces = value;
        break;
      case "internalId":
        this.state.product.internalId = value;
        break;
      case "hsnCode":
        this.state.product.hsnCode = value;
        break;
      case "batchId":
        this.state.product.batchId = value;
        break;
      case "qualityId":
        this.state.product.qualityId = value;
        break;
      case "weight":
        this.state.product.weight = value;
        break;
      case "unit":
        this.state.product.unit = value;
        break;
      case "subCategoryId":
        this.state.product.subCategoryId = value;
        break;
      case "price":
        if (Number(value)) this.state.product.price = value;
        break;
      case "instock":
        this.state.product.instock = value;
        break;
      case "warehouseId":
        this.state.product.warehouseId = value;
        break;
      case "remarks":
        this.state.product.remarks = value;
        break;
    }
    this.setState({ product: this.state.product });
  };

  componentDidMount() {
    // this.GetCategories();
    this.state.product.warehouseId = this.props.warehouseId;
    this.state.product.productVariantType = this.context.storeSettings
      .defaultProductVariantType
      ? this.context.storeSettings.defaultProductVariantType
      : 1;
    this.state.product.unit = this.context.storeSettings.defaultUnit
      ? this.context.storeSettings.defaultUnit
      : "piece";
    this.setState({ product: this.state.product });
    this.setState();

    if (document.getElementById("name") != null)
      document.getElementById("name").focus();
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.state.product.name != "" && this.state.product.unit != "")
      this.AddProductInDB();
  };

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="productModal"
        >
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Edit "
                  : "Add Product to Inventory"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <FloatingLabel label="Warehouse *" className="mb-1">
                    <Form.Select
                      type="text"
                      name="warehouseId"
                      size="lg"
                      value={this.state.product.warehouseId}
                      align="center"
                      required
                      disabled
                      className="text-start "
                      autoComplete="off"
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value={""}></option>
                      {this.props.warehouse.map((m) => (
                        <>
                          <option value={m.id}>{m.name}</option>
                        </>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                  <Row>
                    <Col md={4}>
                      <FloatingLabel label="Product Name *" className="mb-1">
                        <Form.Control
                          type="text"
                          id="name"
                          size="lg"
                          name="name"
                          maxlength="99"
                          autoFocus
                          value={this.state.product.name}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </FloatingLabel>
                    </Col>
                    {this.state.product.productVariantType == 3 ? (
                      <>
                        <Col md={2}>
                          <FloatingLabel label="Thickness *" className="mb-3">
                            <Form.Control
                              type="decimal"
                              name="thickness"
                              className="text-center"
                              required
                              style={{ fontSize: "16px" }}
                              value={this.state.product.thickness}
                              autoComplete="off"
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col md={2}>
                          <FloatingLabel label="Width *" className="mb-3">
                            <Form.Control
                              type="decimal"
                              name="width"
                              className="text-center"
                              required
                              style={{ fontSize: "16px" }}
                              value={this.state.product.width}
                              autoComplete="off"
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col md={2}>
                          <FloatingLabel label="Length *" className="mb-3">
                            <Form.Control
                              type="decimal"
                              name="length"
                              className="text-center"
                              required
                              style={{ fontSize: "16px" }}
                              value={this.state.product.length}
                              autoComplete="off"
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    <Col md={2}>
                      <FloatingLabel label="Unit *" className="mb-3">
                        <Form.Select
                          type="text"
                          name="unit"
                          size="lg"
                          value={this.state.product.unit}
                          placeholder=""
                          required
                          align="center"
                          className="text-start  "
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value={""}></option>
                          <option value={"piece"}>piece</option>
                          <option value={"gram"}>gram</option>
                          <option value={"kg"}>kg</option>
                          <option value={"ton"}>ton</option>
                          <option value={"ml"}>ml</option>
                          <option value={"liter"}>liter</option>
                          <option value={"meter"}>meter</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <FloatingLabel label="Remarks" className="mb-3">
                    <Form.Control
                      type="text"
                      id="remarks"
                      size="lg"
                      name="remarks"
                      maxlength="99"
                      autoFocus
                      value={this.state.product.remarks}
                      placeholder=""
                      autoComplete="off"
                      onChange={(e) => this.handleInputChange(e)}
                    />
                  </FloatingLabel>
                  <Row>
                    <Col>
                      <FloatingLabel label="Main Category *" className="mb-1">
                        <Form.Select
                          name="mainCategoryId"
                          value={this.state.mainCategoryId}
                          required
                          onChange={(e) => {
                            this.setState(
                              { mainCategoryId: e.target.value },
                              () => {
                                this.state.product.subCategoryId = 0;
                                this.setState({ product: this.state.product });
                              }
                            );
                          }}
                        >
                          <option value="">-- Select Main Category --</option>
                          {this.context.mainCategories.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                              {cat.name}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col>
                      {/* Sub Category */}
                      <FloatingLabel label="Sub Category *" className="mb-1">
                        <Form.Select
                          name="subCategoryId"
                          value={this.state.product.subCategoryId}
                          required
                          onChange={this.handleInputChange}
                        >
                          <option value="">-- Select Sub Category --</option>
                          {this.context.subCategories
                            .filter(
                              (sub) =>
                                sub.mainCategoryId === this.state.mainCategoryId
                            )
                            .map((sub) => (
                              <option key={sub.id} value={sub.id}>
                                {sub.name}
                              </option>
                            ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col>
                      <FloatingLabel
                        label="Product Variant Type *"
                        className="mb-3"
                      >
                        <Form.Select
                          name="productVariantType"
                          value={this.state.product.productVariantType}
                          autoComplete="off"
                          onChange={this.handleInputChange}
                        >
                          <option value={1}>Single</option>
                          <option value={2}>MultipleType</option>
                          <option value={3}>SteelType</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>

                  {/* SteelType */}
                  <Row>
                    <Col>
                      <FloatingLabel
                        label={
                          this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS
                            ? "SCNO"
                            : "InternalId"
                        }
                        className="mb-1"
                      >
                        <Form.Control
                          type="text"
                          size="lg"
                          className="pd-2 w-100"
                          name="internalId"
                          value={this.state.product.internalId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col>
                      <FloatingLabel
                        label={
                          this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS
                            ? "CoilId"
                            : "BatchId"
                        }
                        className="mb-1"
                      >
                        <Form.Control
                          type="text"
                          size="lg"
                          className="pd-2 w-100"
                          name="batchId"
                          value={this.state.product.batchId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col>
                      <FloatingLabel label="HSNCode" className="mb-1">
                        <Form.Control
                          type="text"
                          size="lg"
                          className="pd-2 w-100"
                          name="hsnCode"
                          value={this.state.product.hsnCode}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col>
                      <FloatingLabel
                        label={
                          this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS
                            ? "Test Report No"
                            : "Quality No"
                        }
                        className="mb-1"
                      >
                        <Form.Control
                          type="text"
                          size="lg"
                          className="pd-2 w-100"
                          name="qualityId"
                          value={this.state.product.qualityId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button
                  variant="primary"
                  size="lg"
                  // onClick={(e) => this.handleSubmit(e)}
                  type="submit"
                >
                  Add
                </Button>
              </Form.Group>

              <Button
                variant="danger"
                size="lg"
                onClick={(e) => {
                  this.props.onHide();
                }}
              >
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

class SalesOrdersDashboardModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      summary: null,
    };
  }

  componentDidMount() {
    if (this.props.show) {
      this.loadSummary();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.loadSummary();
    }
  }

  // Normalizes API response keys (case-insensitive) into canonical keys
  normalizeSummary = (raw) => {
    if (!raw || typeof raw !== "object") return raw;

    // helper to read either PascalCase or camelCase (or any case) safely
    const r = (k1, k2) =>
      raw[k1] ?? raw[k2] ?? raw[k1.toLowerCase()] ?? raw[k2?.toLowerCase()];

    const normalized = {
      // counts
      StatusCounts: r("StatusCounts", "statusCounts") ?? {},
      PaymentCounts: r("PaymentCounts", "paymentCounts") ?? {},

      // totals
      TotalOrders: r("TotalOrders", "totalOrders") ?? 0,
      TotalRevenue: r("TotalRevenue", "totalRevenue") ?? 0,
      TodayOrders: r("TodayOrders", "todayOrders") ?? 0,
      TodayRevenue: r("TodayRevenue", "todayRevenue") ?? 0,

      // series / arrays
      Last7Days: r("Last7Days", "last7Days") ?? [],
      TopProducts: r("TopProducts", "topProducts") ?? [],
      RecentOrders: r("RecentOrders", "recentOrders") ?? [],
      // preserve original in case needed
      __raw: raw,
    };

    return normalized;
  };

  loadSummary = async () => {
    try {
      this.setState({ loading: true, error: null });
      const token = this.context?.userData?.bearertoken;
      const headers = {};
      if (token) headers.Authorization = `Bearer ${token}`;

      const storeId = this.context?.storeId ?? "";
      const base = process.env.REACT_APP_API ?? "";
      const url = `${base}SalesOrder/GetSummary/${storeId}`;

      const res = await fetch(url, { method: "GET", headers });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`Server returned ${res.status}: ${txt}`);
      }

      const json = await res.json();

      // Normalize keys (this is the critical fix)
      const normalized = this.normalizeSummary(json);

      // helpful debug while developing — remove or toggle off in production
      /* eslint-disable no-console */
      console.log("SalesOrders summary (raw):", json);
      console.log("SalesOrders summary (normalized):", normalized);
      /* eslint-enable no-console */

      this.setState({ summary: normalized, loading: false });
    } catch (err) {
      console.error("Failed to load dashboard summary", err);
      this.setState({ error: String(err.message || err), loading: false });
    }
  };

  // helpers to build chart datasets (unchanged)
  buildStatusPieData = (summary) => {
    const labels = ["New", "Partially Delivered", "Delivered", "Cancelled"];
    const data = [
      summary?.StatusCounts?.[1] ?? 0,
      summary?.StatusCounts?.[2] ?? 0,
      summary?.StatusCounts?.[3] ?? 0,
      summary?.StatusCounts?.[4] ?? 0,
    ];
    return { labels, datasets: [{ data }] };
  };

  buildPaymentPieData = (summary) => {
    const labels = ["Paid", "Unpaid", "Partially Paid"];
    const data = [
      summary?.PaymentCounts?.[1] ?? 0,
      summary?.PaymentCounts?.[2] ?? 0,
      summary?.PaymentCounts?.[3] ?? 0,
    ];
    return { labels, datasets: [{ data }] };
  };

  buildLast7LineData = (summary) => {
    const labels = (summary?.Last7Days || []).map(
      (d) => d.Date ?? d.date ?? d.dateIso ?? d.dateIsoString ?? ""
    );
    const orders = (summary?.Last7Days || []).map(
      (d) => d.Orders ?? d.orders ?? 0
    );
    const revenue = (summary?.Last7Days || []).map(
      (d) => d.Revenue ?? d.revenue ?? 0
    );
    return {
      labels,
      datasets: [
        {
          label: "Orders",
          data: orders,
          fill: false,
          tension: 0.3,
          yAxisID: "y",
        },
        {
          label: "Revenue",
          data: revenue,
          fill: false,
          tension: 0.3,
          yAxisID: "y1",
        },
      ],
    };
  };

  buildTopProductsBarData = (summary) => {
    const top = summary?.TopProducts || [];
    const labels = top.map(
      (t) => t.ProductName ?? t.productName ?? t.Name ?? ""
    );
    const qty = top.map((t) => t.TotalQty ?? t.totalQty ?? t.qty ?? 0);
    return { labels, datasets: [{ label: "Qty Ordered", data: qty }] };
  };

  render() {
    const { show, onHide } = this.props;
    const { loading, error, summary } = this.state;

    return (
      <Modal
        show={show}
        onHide={() => {
          onHide && onHide();
        }}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sales Orders — Analytics Dashboard</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ minHeight: 300 }}>
          {loading && (
            <div>
              Loading summary... &nbsp; <LoadSpinner open />
            </div>
          )}
          {error && (
            <div className="alert alert-danger">
              Error loading dashboard: {error}
            </div>
          )}

          {!loading && !error && !summary && (
            <div className="text-muted">No data available</div>
          )}

          {summary && (
            <div>
              <Row className="mb-3">
                <Col md={4}>
                  <div className="p-2 border rounded">
                    <h6>Total Orders</h6>
                    <div style={{ fontSize: 28, fontWeight: 700 }}>
                      {summary.TotalOrders ?? 0}
                    </div>
                    <small className="text-muted">
                      Orders Today: {summary.TodayOrders ?? 0}
                    </small>
                    <div>
                      <small className="text-muted d-block">
                        Total Revenue:{" "}
                        {(summary.TotalRevenue ?? 0).toLocaleString()}
                      </small>
                      <small className="text-muted d-block">
                        Revenue Today:{" "}
                        {(summary.TodayRevenue ?? 0).toLocaleString()}
                      </small>
                    </div>
                  </div>
                </Col>

                <Col md={8}>
                  <div className="d-flex gap-2">
                    <div style={{ flex: 1 }} className="p-2 border rounded">
                      <h6 className="mb-2">Order Status</h6>
                      <div style={{ height: 220 }}>
                        <Pie
                          data={this.buildStatusPieData(summary)}
                          options={{
                            plugins: { legend: { position: "bottom" } },
                          }}
                        />
                      </div>
                    </div>

                    <div style={{ flex: 1 }} className="p-2 border rounded">
                      <h6 className="mb-2">Payment Status</h6>
                      <div style={{ height: 220 }}>
                        <Pie
                          data={this.buildPaymentPieData(summary)}
                          options={{
                            plugins: { legend: { position: "bottom" } },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={8}>
                  <div className="p-2 border rounded">
                    <h6>Last 7 Days — Orders & Revenue</h6>
                    <div style={{ height: 260 }}>
                      <Line
                        data={this.buildLast7LineData(summary)}
                        options={{
                          responsive: true,
                          interaction: { mode: "index", intersect: false },
                          stacked: false,
                          scales: {
                            y: {
                              type: "linear",
                              display: true,
                              position: "left",
                              title: { display: true, text: "Orders" },
                            },
                            y1: {
                              type: "linear",
                              display: true,
                              position: "right",
                              grid: { drawOnChartArea: false },
                              title: { display: true, text: "Revenue" },
                            },
                          },
                          plugins: { legend: { position: "bottom" } },
                        }}
                      />
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="p-2 border rounded">
                    <h6>Top Products</h6>
                    <div style={{ height: 260 }}>
                      <Bar
                        data={this.buildTopProductsBarData(summary)}
                        options={{
                          indexAxis: "y",
                          plugins: { legend: { display: false } },
                          scales: { x: { beginAtZero: true } },
                        }}
                      />
                    </div>
                    <small className="text-muted d-block mt-2">
                      Top products by qty ordered
                    </small>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className="p-2 border rounded">
                    <h6>Recent Orders Preview</h6>
                    <Table size="sm" striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>OrderId</th>
                          <th>Customer</th>
                          <th>Created</th>
                          <th>Paid</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(summary.RecentOrders || [])
                          .slice(0, 8)
                          .map((r, idx) => (
                            <tr key={r.Id || r.OrderId || idx}>
                              <td>{idx + 1}</td>
                              <td>{r.OrderId ?? r.orderId ?? ""}</td>
                              <td>{r.CustomerName ?? r.customerName ?? ""}</td>
                              <td>
                                {r.Created
                                  ? new Date(r.Created).toLocaleString()
                                  : r.created
                                  ? new Date(r.created).toLocaleString()
                                  : ""}
                              </td>
                              <td>{r.PaidAmount ?? r.paidAmount ?? 0}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              this.props.refreshParent && this.props.refreshParent();
              this.props.onHide && this.props.onHide();
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={this.loadSummary}>
            Refresh Dashboard
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SalesOrdersDashboardModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  refreshParent: PropTypes.func,
};

SalesOrdersDashboardModal.defaultProps = {
  show: false,
  onHide: null,
  refreshParent: null,
};

export class AddOrEditSalesOrderPayment extends Component {
  constructor(props) {
    super(props);

    const p =
      props.Type === "Edit" && props.payment
        ? { ...props.payment }
        : {
            id: "",
            paymentDate: new Date().toISOString().split("T")[0],
            paymentMethod: 1,
            paymentTransactionId: "",
            amount: 0,
            notes: "",
          };

    this.state = { payment: p };
  }

  // Local fallback mapping (you can override by passing GetPaymentMethodName prop)
  GetPaymentMethodName = (id) => {
    const map = {
      1: "Cash",
      2: "Bank Transfer",
      3: "Cheque",
      4: "UPI",
      5: "Other",
    };
    return map[id] || "Unknown";
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      payment: {
        ...prev.payment,
        [name]: name === "amount" ? Number(value) : value,
      },
    }));
  };

  handleSubmit = (e) => {
    // STOP event from bubbling up to parent form
    e.preventDefault();
    e.stopPropagation();

    const p = { ...this.state.payment };

    if (!p.amount || Number(p.amount) <= 0) {
      alert("Enter payment amount");
      return;
    }
    if (!p.paymentDate) {
      alert("Enter payment date");
      return;
    }

    if (!p.id) p.id = this.generateGuid();

    if (this.props.Type === "Edit") {
      this.props.UpdatePayment?.(p, this.props.Index);
    } else {
      this.props.AddPayment?.(p);
    }

    // Let the parent decide how to close the payment modal.
    // In your SalesOrderAddOrEditModal you already pass onHide={this.onHidePaymentModal}
    this.props.onHide?.();
  };

  generateGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  render() {
    const payment = this.state.payment || {};
    const getName =
      this.props.GetPaymentMethodName || this.GetPaymentMethodName;

    return (
      // prevent accidental parent-close by clicks/ESC
      <Modal
        show
        onHide={() => this.props.onHide?.()}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.Type === "Edit" ? "Edit Payment" : "Add Payment"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel label="Payment Date" className="mb-2">
              <Form.Control
                type="date"
                name="paymentDate"
                value={payment.paymentDate || ""}
                onChange={this.handleChange}
                required
              />
            </FloatingLabel>

            <FloatingLabel label="Payment Method" className="mb-2">
              <Form.Select
                name="paymentMethod"
                value={payment.paymentMethod || 1}
                onChange={this.handleChange}
              >
                <option value={1}>{getName(1)}</option>
                <option value={2}>{getName(2)}</option>
                <option value={3}>{getName(3)}</option>
                <option value={4}>{getName(4)}</option>
                <option value={5}>{getName(5)}</option>
              </Form.Select>
            </FloatingLabel>

            <FloatingLabel label="Transaction / Ref" className="mb-2">
              <Form.Control
                type="text"
                name="paymentTransactionId"
                value={payment.paymentTransactionId || ""}
                onChange={this.handleChange}
              />
            </FloatingLabel>

            <FloatingLabel label="Amount" className="mb-2">
              <Form.Control
                type="number"
                step="0.01"
                min="0"
                name="amount"
                value={payment.amount ?? ""}
                onChange={this.handleChange}
                required
              />
            </FloatingLabel>

            <FloatingLabel label="Notes" className="mb-2">
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                value={payment.notes || ""}
                onChange={this.handleChange}
              />
            </FloatingLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">
              {this.props.Type === "Edit" ? "Update" : "Add"}
            </Button>
            <Button variant="secondary" onClick={() => this.props.onHide?.()}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}
